import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar";
import ProductHeader from "../../component/ProductHeader";
import Footer from "../../component/Footer";
import Images from "../../assets/Image";
import { FaDownload } from "react-icons/fa";
import ContactUsFooter from "../../component/ContactUsFooter";
import MostlyViewed from "../../component/MostlyViewed";
import FilePdf from "../../broucherPdf/filePdf";
import usptto from "../../assets/usptto.png"

export default function UspTtoRibbons() {
  const [specificationVisible, setSpecificationVisible] = useState(false);
  const [youtubeVideoVisible, setYoutubeVideoVisible] = useState(false);
  const [printerDetailsVisible, setPrinterDetailsVisible] = useState(false);
  const containerRef = useRef(null);
  const youtubeContainerRef = useRef(null);
  const printerDetailsRef = useRef(null);

  const leftSidePrinterSpecification = [
    {
      title: "Ribbon Grade",
      data: "RESIN, NEAR-EDGE",
    },
    {
      title: "Color",
      data: "Black",
    },
    {
      title: "Thickness",
      data: "7.0 ± 0.5 μm",
    },
    {
      title: "Base Flim",
      data: "Polyster(4.0 ± 0.1 μm)",
    },
    {
      title: "Back Coat",
      data: "Silicone based",
    },
    {
      title: "Ink Melting Point",
      data: "80°C",
    },
  ];
  const rightSidePrinterSpecification = [
    {
      title: "Heavy Metals",
      data: "2011/65/EU,(EU)2015/863(RoHS, RoHS2.0)",
    },
    {
      title: "Reach",
      data: "SVHC free",
    },
    {
      title: "Halogen-free",
      data: "IEC 61249-2-21",
    },
    {
      title: "Storage",
      data: "0-40°C (32-104°F), 20-80%RH",
    },
    {
      title: "Use",
      data: "5-35°C (41-95°F), 20-80%RH",
    },
    {
      title: "label Stock",
      data: "PET, Nylon",
    },
  ];

  const foodAndBeverage1 = [
    {
      productImg: Images?.industry5,
      label: "Food & Beverage",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSpecificationVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setYoutubeVideoVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (youtubeContainerRef.current) {
      observer.observe(youtubeContainerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPrinterDetailsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (printerDetailsRef.current) {
      observer.observe(printerDetailsRef.current);
    }

    return () => observer.disconnect();
  }, []);
  const downloadLinkRef = useRef(null);

  const handleDivClick = () => {
    if (downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  };
  return (
    <div>
      <Navbar />
      <ProductHeader
        headerTxt="USP TTO RIBBONS"
        printerImg={Images?.uspstream15}
        pdfFile={FilePdf?.usp_TTO_Ribbons}
      />
      <div className="printerPageContainer">
        <div className="printerDetailsContainer">
          <header
            className={`printerDetailsHeader ${printerDetailsVisible ? "animated" : ""
              }`}
          >
            USP TTO RIBBONS
          </header>
          <div
            ref={printerDetailsRef}
            // className="printerDetailsData"
            className={`printerDetailsData ${printerDetailsVisible ? "animated" : ""
              }`}
          >
            RESIN is a "Near Edge / Corner Edge" resin ribbon designed to print
            on to PET and NY films. This ribbon has been coated on to a 4-micron
            base film which results in the ribbon having an excellent smudge,
            scratch and solvent resistance. In addition to this, the ribbon
            performs with an exceptional high peelable adhesives resistance on
            PET and NY films.
          </div>
          <div className="printerDetailsVideo" ref={youtubeContainerRef}>
            {/* <div className="printerYoutubeLink">
              <iframe
                // className={`youtubeVideo `}
                className={`youtubeVideo ${youtubeVideoVisible ? "animated" : ""
                  }`}
                width="300"
                height="250"
                src="https://www.youtube.com/embed/jMFx1pUakkU?si=oDSbquQyGUGkTZEt"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style={{ borderRadius: "6px" }}
              ></iframe>
            </div> */}
            <div>
              <div
                className={`printerBrochure ${youtubeVideoVisible ? "animated" : ""
                  }`}
                style={{ cursor: "pointer" }}
                onClick={handleDivClick}
              >
                <div>
                  <div className="productImageContainer">
                    <img
                      className="w-[100%]"
                      src={usptto}
                      alt=""
                    />
                  </div>
                  {/* Buttons */}
                  <div className="brochureImageButtons">
                    <button className="downloadBrochureBtn">
                      Download Brochure
                    </button>
                  </div>
                  <a
                    href={FilePdf?.usp_TTO_Ribbons}
                    download="Usp TTO Ribbons"
                    ref={downloadLinkRef}
                    style={{ display: "none" }}
                  >
                    Download Brochure
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="printerSpecificationContainer">
          <header className="printerDetailsHeader">Specification</header>
          <div
            ref={containerRef}
            className="printerSpecificationDetailsContainer"
          >
            <div className="leftSideSpecificationContainer">
              {leftSidePrinterSpecification.map((item, index) => (
                <div
                  className={`specificationDetails ${specificationVisible ? "animated" : ""
                    }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
            <div className="rightSideSpecificationContainer">
              {rightSidePrinterSpecification.map((item, index) => (
                <div
                  className={`rightSpecificationDetails ${specificationVisible ? "animated" : ""
                    }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* <div
          style={{ display: "flex", justifyContent: "start  " }}
          className="foodBeverageContainer"
          ref={foodAndBeverageRef}
        >
          {foodAndBeverage1?.map((productDetail, index) => {
            return (
              <div className="foodAndBeverageInnerContainer" key={index}>
                <div className="foodBeverageImgContainer">
                  <img
                    className={`foodAndBeverageImg1 ${
                      foodAndBeverageVisible ? "animated" : ""
                    }`}
                    src={productDetail?.productImg}
                    alt=""
                  />
                </div>
                <div
                  className={`foodAndBeverageName ${
                    foodAndBeverageVisible ? "animated" : ""
                  }`}
                >
                  {productDetail?.label}
                </div>
              </div>
            );
          })}
        </div> */}

        <MostlyViewed />
      </div>
      <ContactUsFooter />
      <Footer />
    </div>
  );
}
